/* eslint-disable import/prefer-default-export */
import get from 'lodash/get';
import { atom } from 'recoil';

export const CurrentCompanyAtom = atom({
  key: 'CurrentCompanyAtom',
  default: Number(get(window, 'company.id', 0)),
});
